module.exports = __webpack_public_path__ + "img/reference1_mobile.2cffff32.png";